<template>
  <div>
    <div class="top">
      <div class="main-width py-5">
        <VBreadcrumb
          :options="[{ label: '首页', to: '/' }, { label: '邮轮港口' }]"
        ></VBreadcrumb>
      </div>
      <section class="main-width" v-if="adStore.state && adStore.state.length">
        <swiper :options="swiperOptions" class="mySwiper">
          <swiper-slide v-for="(item, index) in adStore.state" :key="index">
            <a
              class="block h-full"
              :href="item.url"
              :title="item.title"
              :target="item.target"
            >
              <img class="swiper-img" :alt="item.title" :src="item.path_url" />
            </a>
          </swiper-slide>
          <div class="swiper-pagination" slot="pagination" />
        </swiper>
      </section>
    </div>
    <section class="box">
      <div class="main-width">
        <!-- <ClientOnly> -->
        <ScrollNav
          tag="nav"
          class="mb-3 sticky bg-white z-10"
          :style="{ top: `${stickyOffsetTop}px` }"
          :options="navs"
          :offset="scrollToOffset"
        />
        <!-- </ClientOnly> -->
        <div
          v-for="item in ports"
          class="collapse"
          :key="item.id"
          :id="genSectionId(item.id)"
        >
          <div class="item">
            <div class="route-name">{{ item.name }}</div>
            <nuxt-link
              v-if="showMore(item)"
              class="status"
              :to="`/harbor/city?id=${item.id}`"
              target="_blank"
            >
              查看更多产品
              <span class="arrow">
                <i class="ficon ficon-arrow-right"></i>
              </span>
            </nuxt-link>
          </div>
          <div class="content">
            <div class="route-box">
              <div
                class="route"
                v-for="product in item.product"
                :key="product.id"
              >
                <product-collection-item
                  :info="product"
                ></product-collection-item>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <div class="link-box">
      <nuxt-link
        class="link-btn"
        target="_blank"
        to="/product/automation/foreign-cruise-search"
        >查看其他港口出发产品</nuxt-link
      >
    </div>
    <AppDock />
  </div>
</template>
<script>
import {
  defineComponent,
  useMeta,
  ref,
  // useRouter,
  // onMounted,
  useFetch,
  computed,
} from "@nuxtjs/composition-api";
import { getPortList } from "@/services/harbor";
import VBreadcrumb from "@/components/VBreadcrumb.vue";
import ProductCollectionItem from "@/components/Product-collection-item.vue";
import usePlatformAdvertBanner from "~/composables/usePlatformAdvertBanner";
// import { useRouteHash } from "~/composables/useRouteHash";
// import ScrollActive from "~/components/ScrollActive";
// import { stringify } from "qs";
import defineAsyncComponent from "~/utils/defineAsyncComponent";
import { useAsyncState } from "@vueuse/core";

import { REQUEST_CODES } from "~/constants/const-http";
import useLayout from "~/composables/useLayout";
import ScrollNav from "~/components/ScrollNav.vue";
import AppDock from '~/components/layouts/AppDock.vue'

export default defineComponent({
  name: "destination",
  auth: false,
  head: {},
  components: {
    VBreadcrumb,
    ScrollNav,
    ProductCollectionItem,
    AppDock
  },
  layout: "Main",
  key(route) {
    return route.path
  },
  setup() {
    useMeta(() => ({
      title: "邮轮港口",
    }));
    const adStore = ref(usePlatformAdvertBanner(45));

    const { state, execute } = useAsyncState(
      async () => {
        const { msg, data, code } = await getPortList();
        if (code !== REQUEST_CODES.ERROR_OK) {
          throw new Error(msg);
        }
        return data;
      },
      [],
      {
        immediate: false,
        onError: (err) => console.error(err),
      }
    );
    // onMounted(() => {
    //   execute(0);
    // })
    useFetch(async () => {
      await execute(0);
    });

    const { headerSize } = useLayout();
    const stickyOffsetTop = computed(() => headerSize.height);
    const scrollToOffset = computed(() => headerSize.height + 50);
    const genSectionId = (id) => `section-${id}`;
    const ports = computed(() =>
      state.value.filter((item) => item.product.length > 0)
    );
    const navs = computed(() =>
      ports.value.map((item) => ({
        text: item.name,
        sectionSelector: `#${genSectionId(item.id)}`,
      }))
    );
    return {
      list: state,
      ports,
      navs,
      adStore,
      genSectionId,
      stickyOffsetTop,
      scrollToOffset,
    };
  },
  data() {
    return {
      swiperOptions: {
        slidesPerView: 1,
        spaceBetween: 0,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        autoplay: true,
        lazy: true,
        loop: true,
      },
    };
  },
  methods: {
    showMore(item) {
      return item.product_count > 4;
    },
  }
});
</script>
<style lang="scss" scoped>
.mySwiper {
  height: 240px;
  width: 100%;
  margin-bottom: 30px;
}
.mySwiper .swiper-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.box {
  background-color: #fff;
  padding-bottom: 30px;
}
.collapse {
  width: 100%;
}
.collapse .item {
  height: 60px;
  background-color: #f3f5f8;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 18px 0 20px;
  margin-bottom: 10px;
  cursor: pointer;
}
.collapse .item .route-name {
  font-size: 24px;
  color: #3d3d3d;
  font-weight: 500;
}
.collapse .item .logo {
  width: auto;
  height: 32px;
  margin-left: 16px;
  display: inline-block;
}
.collapse .item .status {
  font-size: 16px;
  color: #3d3d3d;
}
.collapse .item .status:hover {
  color: $color-primary;
}
.collapse .item .status .arrow {
  display: inline-block;
}
.collapse .item .status .rotateUp {
  transform: rotate(180deg);
}
.collapse .item .status .rotateDown {
  transform: rotate(0deg);
}
.collapse .content {
  transition: all 0.4s;
  padding-top: 10px;
}
.route-box {
  margin-right: -16px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -ms-flex-wrap: wrap;
  -webkit-flex-wrap: wrap;
  flex-wrap: wrap;
}
.route-box .route {
  width: 25%;
  margin-bottom: 30px;
  padding-right: 16px;
}
.link-box {
  padding: 50px 0;
  text-align: center;
}
.link-box .link-btn {
  border-radius: 0.25rem;
  display: inline-block;
  height: 2.75rem;
  line-height: 2.75rem;
  text-align: center;
  width: 12.5rem;
  border: 1px solid $color-black-2;
  font-size: 16px;
  color: $color-black-2;
}
.link-box .link-btn:hover {
  color: $color-primary;
  border-color: $color-primary;
}
.nav--active {
  --tw-bg-opacity: 1;
  background-color: rgba(240, 242, 245, var(--tw-bg-opacity));
  --tw-border-opacity: 1;
  border-color: rgba(201, 203, 214, var(--tw-border-opacity));
  border-width: 1px;
  font-weight: 500;
  --tw-text-opacity: 1;
  color: rgba(25, 25, 25, var(--tw-text-opacity));
}
</style>
